import { ParticipationSetsGridColDef } from '../../types';

type Value = string | null | undefined;

export const symbolColDef: ParticipationSetsGridColDef<Value> = {
  headerName: 'Symbol',
  field: 'offering.issuer.primarySymbol',
  filter: 'agTextColumnFilter',
  floatingFilter: true,
  width: 102,
};
